import TextField from "@material-ui/core/TextField";
import styled from "styled-components";

export const Input = styled(TextField).attrs({
  variant: "outlined"
})`
  && {
    width: 100%;
  }
`;
